import React, { memo } from "react";

import type { TypeEmptyStateProps } from "./EmptyStateTypes";
import EmptyStateHybrid from "./EmptyStateHybrid";

/**
 * EmptyState component. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (for
 * consumers using styled-system props or a styled() extension).
 */
const EmptyState = React.forwardRef<HTMLDivElement, TypeEmptyStateProps>(
  (props, ref) => <EmptyStateHybrid {...props} ref={ref} />
);

EmptyState.displayName = "EmptyState";

export default memo(EmptyState);
